import classNames from "classnames";
import React from "react";
import { TrainingCenterBundleItemVideoMediaOverlay } from "../../../system/AppState/AppStateTrainingCenter";
import { If } from "../../Generic/If";
import { IsDefined } from "../../Generic/IsDefined";
import {
  lookupTranslationRequired,
  TrainingCenterLanguagePreference,
} from "../TrainingCenterLanguageLookup";

interface Props {
  mediaOverlay: TrainingCenterBundleItemVideoMediaOverlay;
  languagePreference: TrainingCenterLanguagePreference;
  images: Map<string, HTMLImageElement> | undefined;
}

const TrainingCenterVideoMediaOverlay = (props: Props) => {
  const { title, description, imageUrl, imageWidth } = React.useMemo(
    () =>
      lookupTranslationRequired(props.languagePreference, props.mediaOverlay.overlayData, (x) => x),
    [props.languagePreference, props.mediaOverlay.overlayData]
  );

  const imageObj: HTMLImageElement | undefined = React.useMemo(() => {
    return imageUrl !== undefined && props.images !== undefined
      ? props.images.get(imageUrl)
      : undefined;
  }, [imageUrl, props.images]);

  return (
    <div
      className={classNames("TrainingCenterVideoMediaOverlay", {
        "position-top": props.mediaOverlay.position === "TOP",
        "position-center": props.mediaOverlay.position === "CENTER",
        "position-bottom": props.mediaOverlay.position === "BOTTOM",
      })}
    >
      <If condition={title !== undefined && title !== ""}>
        <div className="_title">
          <span>{title}</span>
        </div>
      </If>
      <If condition={description !== undefined && description !== ""}>
        <div className="_description">
          <span>{description}</span>
        </div>
      </If>
      <IsDefined value={imageObj}>
        {(image) => (
          <div className="_imageUrlContainer">
            <img
              style={{ width: imageWidth !== undefined ? `${imageWidth}%` : "auto" }}
              className="_imageUrl"
              src={image.src}
            />
          </div>
        )}
      </IsDefined>
    </div>
  );
};

export default TrainingCenterVideoMediaOverlay;
